const createCalendarTokens = ({ colors }) => ({
  colors: {
    default: {
      bg: colors.neutral['0'],
      color: colors.neutral['90'],
      region: colors.primary['50'],
      global: colors.primary['30'],
    },
    disabled: {
      bg: colors.neutral['0'],
      color: colors.neutral['40'],
      region: colors.primary['50'],
      global: colors.primary['30'],
    },
    selected: {
      bg: colors.primary['50'],
      color: colors.neutral['0'],
      region: colors.primary['20'],
      global: colors.primary['30'],
    },
    inRange: {
      bg: colors.primary['20'],
      color: colors.primary['50'],
      region: colors.primary['50'],
      global: colors.primary['30'],
    },
    title: {
      color: colors.neutral['90'],
    },
  },
});

export default createCalendarTokens;
